import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class SeverityService {
    getSeverity(status: string) {
        if (!status) {
            return;
        }
        const normalizedStatus = status.toLowerCase().trim();

        switch (normalizedStatus) {
            case 'attivo':
            case 'attiva':
                return 'success';
            case 'disattivo':
                return 'danger';
            case 'scaduta':
                return 'secondary';
            case 'sospesa':
                return 'warn';
            case 'in attivazione':
                return 'info';
            case 'revocata':
                return 'danger';
            // Stati degli ordini ecommerce
            case 'pagato':
                return 'success';
            case 'in attesa di pagamento':
            case 'in attesa di bonifico':
                return 'warn';
            case 'annullato':
                return 'danger';
            case 'in elaborazione':
                return 'info';
            default:
                return 'info';
        }
    }
}
